import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {
  NgZorroAntdModule,
  NzMenuModule,
} from 'ng-zorro-antd';
import {CallModule} from '../customers/call/call.module';
import {Routes, RouterModule} from '@angular/router';
import {LoyaltyComponent} from './loyalty.component';
import {NgxBarcodeModule} from 'ngx-barcode';

const routes: Routes = [
  {
    path: '',
    component: LoyaltyComponent,
  }
];

@NgModule({
  declarations: [
    LoyaltyComponent,
  ],
  imports: [
    CommonModule,
    NzMenuModule,
    FormsModule,
    NgZorroAntdModule,
    ReactiveFormsModule,
    CallModule,
    RouterModule.forChild(routes),
    NgxBarcodeModule,

  ]
})
export class LoyaltyModule {
}
